if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (!this.form) return;

        this._useRebuy = false;
        this.decideSubmissionMode();
        this.onRebuyReady(() => this.decideSubmissionMode());

        this.form.querySelector("[name=id]").disabled = false;

        if (!this._useRebuy) {
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }

        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.stickyATC = document.querySelector(".sticky-atc-button");
        const stickyATCButton = document.querySelector(".sticky-atc-button__atc");
        if (stickyATCButton) {
          stickyATCButton.addEventListener("click", (evt) => {
            const buttonProductId = stickyATCButton.dataset.productId;
            const formProductId = this.form?.dataset.productId;
            if (buttonProductId !== formProductId) return;

            if (this._useRebuy) {
              // Let Rebuy intercept a real submit
              this.form.requestSubmit?.() || this.form.submit();
            } else {
              this.onSubmitHandler(evt);
            }
          });
        }

        if (this.stickyATC) {
          this.getStickyATCHeight();
          window.addEventListener("resize", this.getStickyATCHeight.bind(this));
        }

        if (document.querySelector("cart-drawer")) this.submitButton?.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
        this.initSubscription();
        const mainSubmitButton = document.querySelector(".product-form__submit") || document.querySelector(".subscription-add-to-cart");
        if (mainSubmitButton) {
          this.initObserver(mainSubmitButton);
        }
      }

      decideSubmissionMode() {
        // Re-check settings and flip listeners if needed
        const shouldUseRebuy = this.rebuyWantsToIntercept();
        if (shouldUseRebuy === this._useRebuy) return;

        this._useRebuy = shouldUseRebuy;

        // Toggle our AJAX submit listener accordingly
        if (this._useRebuy) {
          this.form.removeEventListener("submit", this.onSubmitHandler); // in case previously attached
        } else {
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }
      }

      rebuyWantsToIntercept() {
        try {
          const smartCart = window.Rebuy?.SmartCart;
          const settings  = smartCart?.settings || smartCart?.config || smartCart?.options || {};
          const redirect   = String(settings.product_form_redirect ?? settings.productFormRedirect ?? '').toLowerCase();
          const redirectId = String(settings.product_form_redirect_id ?? settings.productFormRedirectId ?? '');
          // Your rule: Rebuy intercepts when "none" or id "1"
          return (redirect === 'none' || redirectId === '1');
        } catch (_) { return false; }
      }

      onRebuyReady(cb) {
        if (window.Rebuy?.callbacks?.ready?.add) { window.Rebuy.callbacks.ready.add(cb); return; }
        if (window.Rebuy?.callbacks?.init?.add)  { window.Rebuy.callbacks.init.add(cb);  return; }

        let fired = false;
        const handler = () => { if (!fired) { fired = true; cb(); } };
        window.addEventListener('rebuy:ready', handler, { once:true, passive:true });
        window.addEventListener('rebuy:init',  handler, { once:true, passive:true });

        const t = setInterval(() => {
          const st = window.Rebuy?._status || window.Rebuy?.status;
          if (st === 'initialized' || st === 'ready') { clearInterval(t); handler(); }
        }, 250);
      }

      getSectionsToRender() {
        return [
          {
            id: "cart-icon-bubble",
          },
        ];
      }

      getStickyATCHeight() {
        const htmlEl = document.documentElement;
        const stickyHeight = this.stickyATC.offsetHeight;
        htmlEl.style.setProperty("--sticky-atc-height", `${stickyHeight}px`);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton?.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton?.setAttribute("aria-disabled", true);
        this.submitButton?.classList.add("loading");
        this.querySelector(".loading__spinner")?.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form || undefined);

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton?.querySelector(".sold-out-message");
              if (!soldOutMessage) return;

              this.submitButton?.setAttribute("aria-disabled", true);
              this.submitButton?.querySelector("span")?.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton?.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton?.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner")?.classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      tooltipContent(id, title, srOnly, content, labelLink, link, mode) {
        const cleanedContent = this.cleanContent(content);
        const learnMoreConetnt = this.generateCta(labelLink, link);
        return `
        <div class="tooltip-container ${mode} hidden">
          <button class="trigger tooltip-trigger" aria-expanded="false" aria-controls="subscription-tooltip-${id}">
            <span class="fas fa-question" aria-hidden="true"></span>
            <span class="sr-only">${srOnly}</span>
          </button>
          <div id="subscription-tooltip-${id}" class="tooltip" role="tooltip">
            <div class="title"><span class="icon"></span>${title}</div>
            <div class="content">${cleanedContent}</div>
          </div>
          ${learnMoreConetnt}
        </div>`;
      }

      cleanContent(content) {
        return content
          .replace(/\\ead2/g, '<p class="content__text">')
          .replace(/\\00a0/g, '<span class="content__icon"></span>')
          .replace(/\\a/g, "</p>")
          .trim();
      }

      generateCta(label, link) {
        if (!label || !link) return "";
        return `<a href="${link}" tabindex="-1" class="content_cta">${label}</a>`;
      }

      addTriggerCloseTooltip() {
        const triggerButtons = document.querySelectorAll(".tooltip-trigger");
        if (!triggerButtons.length) return;
        triggerButtons.forEach((triggerButton) =>
          triggerButton.addEventListener("click", (e) => {
            e.preventDefault();
            const tooltipContainers = document.querySelectorAll(".tooltip-container");
            if (!tooltipContainers.length) return;
            tooltipContainers.forEach((tooltipContainer) => {
              !tooltipContainer?.classList.contains("hidden") && tooltipContainer.classList.add("hidden");
            });
          })
        );
      }

      addTriggerOpenTooltip() {
        const tooltipEls = document.querySelectorAll(".rc_widget__option__discount[data-label-discount]");
        if (!tooltipEls.length) return;
        tooltipEls.forEach((tooltipEl) => {
          tooltipEl.addEventListener("click", () => {
            const tooltipContainers = document.querySelectorAll(".tooltip-container");
            if (!tooltipContainers.length) return;
            tooltipContainers.forEach((tooltipContainer) => {
              tooltipContainer?.classList.contains("hidden") && tooltipContainer.classList.remove("hidden");
            });
          });
        });
      }

      setStickyPrice() {
        const stickyPrices = document.querySelectorAll(".price--sticky__inner");
        const originPriceEl = document.querySelector("[data-selector-current-price]");
        const originPrice = originPriceEl && getComputedStyle(originPriceEl)?.getPropertyValue("--var-product-price");
        const formatedPrice = originPrice && originPrice.replace(/'/g, "").trim();
        const variantsPrice = this.querySelectorAll(".rc_widget__option__input");
        variantsPrice.forEach((variantPrice) => {
          if (!variantPrice.checked) return;
          const lablePrice = variantPrice.nextSibling?.querySelector(".rc-option__price")?.innerHTML;
          stickyPrices.forEach((stickyPrice) => {
            stickyPrice.innerHTML = lablePrice;

            if (stickyPrice.nextElementSibling) {
              if (formatedPrice === lablePrice) {
                stickyPrice.nextElementSibling.textContent = "";
              } else {
                stickyPrice.nextElementSibling.textContent = formatedPrice;
              }
            }
          });
        });
      }

      watchThumbnailChange() {
        const variantImages = document.querySelectorAll("[data-selector-current-variant]");
        if (variantImages.length) {
          const stickyATCImage = document.querySelector(".sticky-atc-button__image");
          variantImages.forEach((variantImage) => {
            variantImage.addEventListener("click", () => {
              const imageUrl = variantImage.querySelector("img")?.src;
              if (!imageUrl || !stickyATCImage) return;
              stickyATCImage.src = imageUrl;
            });
          });
        }
      }

      whatVariantChange() {
        const variantOptions = document.querySelectorAll("[data-selector-variant-option]");
        if (variantOptions.length) {
          const stickyATCVariant = document.querySelector(".sticky-atc-button__variant");
          variantOptions.forEach((variantOption) => {
            variantOption.addEventListener("change", (e) => {
              if (!e.target || !e.target.checked || !stickyATCVariant) return;

              stickyATCVariant.textContent = e.target.value;
            });
          });
        }
      }

      initSubscription() {
        let isInit = false;

        const callback = (mutationList) => {
          for (const mutation of mutationList) {
            if (mutation.type === "childList") {
              this.setStickyPrice();
              const subSave = this.querySelector("[data-selector-subsave]");
              const priceDesktop = document.querySelector(".price--desktop");
              const priceMobile = document.querySelector(".price--mobile");
              const priceLastDesktop = priceDesktop && priceDesktop.querySelector(".price-item--last");
              const priceLastMobile = priceMobile && priceMobile.querySelector(".price-item");

              if (priceLastDesktop && priceLastMobile) {
                priceLastMobile.textContent = priceLastDesktop.textContent;

                this.form?.addEventListener("change", (e) => {
                  const dataPrice = e.target.nextSibling?.querySelector(".rc-option__price");
                  if (dataPrice) {
                    priceLastMobile.textContent = dataPrice.textContent;
                  }
                });
              }

              if (subSave && !isInit) {
                const subSaveLabel = subSave && subSave.querySelector("[data-label-subsave]");
                const subSaveLabelText = subSave && subSave.querySelector("[data-label-text-subsave]");
                const subSaveLabelDiscount = subSave && subSave.querySelector("[data-label-discount]");
                const id = subSaveLabel && subSaveLabel.getAttribute("for");
                const title = `${subSaveLabelText?.innerHTML || ""} ${subSaveLabelDiscount?.innerHTML || ""}`;
                isInit = true;

                if (subSaveLabelDiscount) {
                  const tooltipHtml = this.tooltipContent(
                    id,
                    title,
                    this.dataset.srOnly,
                    this.dataset.subscriptionText,
                    this.dataset.ctaLabel,
                    this.dataset.ctaLink,
                    "desktop-mode"
                  );
                  const tooltipMobileHtml = this.tooltipContent(
                    id,
                    title,
                    this.dataset.srOnly,
                    this.dataset.subscriptionText,
                    this.dataset.ctaLabel,
                    this.dataset.ctaLink,
                    "mobile-mode"
                  );
                  subSaveLabelDiscount.insertAdjacentHTML("afterend", tooltipHtml);
                  document.querySelector("#MainContent")?.insertAdjacentHTML("afterend", tooltipMobileHtml);
                  this.addTriggerCloseTooltip();
                  this.addTriggerOpenTooltip();
                }
              }
              this.whatVariantChange();
              this.watchThumbnailChange();
            }
          }
        };

        const observer = new MutationObserver(callback);
        observer.observe(this, { attributes: true, childList: true, subtree: true });
      }

      initObserver(mainSubmitButton) {
        const footer = document.querySelector("site-footer");

        const isFooterVisible = () => {
          if (!footer) return false;
          const rect = footer.getBoundingClientRect();
          return rect.top < window.innerHeight && rect.bottom >= 0;
        };

        let isStickyActive = false;
        let formVisible = true;
        let formAboveViewport = false;

        const setSticky = (active) => {
          if (active === isStickyActive) return;
          isStickyActive = active;
          this.stickyATC?.classList.toggle("actived", active);
          document.body.classList.toggle("sticky-atc-active", active);
        };

        const updateStickyState = () => {
          if (isFooterVisible()) {
            setSticky(false);
            return;
          }

          setSticky(!formVisible && formAboveViewport);
        };

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            formVisible = entry.isIntersecting;
            formAboveViewport = entry.boundingClientRect.top < 0;
            updateStickyState();
          });
        }, { root: null, rootMargin: "0px", threshold: 0 });
        observer.observe(mainSubmitButton);
        window.addEventListener("scroll", updateStickyState);
      }
    }
  );
}
